import { useCallback, useEffect, useState } from 'react';
import { NotificationState } from '../types';

export const useNotification = (autoHideMs?: number) => {
  const [notification, setNotification] = useState<NotificationState>({
    open: false,
    message: '',
    severity: 'success',
  });

  const showNotification = useCallback((message: string, severity: 'success' | 'error') => {
    setNotification({ open: true, message, severity });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(prev => ({ ...prev, open: false }));
  }, []);

  useEffect(() => {
    if (!autoHideMs || !notification.open) return;
    const t = setTimeout(hideNotification, autoHideMs);
    return () => clearTimeout(t);
  }, [autoHideMs, notification.open, notification.message, hideNotification]);

  return {
    notification,
    setNotification,
    showNotification,
    hideNotification,
  };
};
